import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Select from 'react-select';

import { Addon } from 'react-bootstrap/lib/InputGroup';

import { saveText } from '../../core/save';

import Tooltip from '../Tooltip';

const Filter = ({ dataField, fields = [] } = {}) => ComposedComponent =>
  class FilterComponent extends Component {
    static propTypes = {
      getField: PropTypes.func,
      saveFields: PropTypes.arrayOf(PropTypes.string),
      saveHeaders: PropTypes.arrayOf(PropTypes.string),
      saveFile: PropTypes.string,
      filterSelect: PropTypes.bool,
      selectOptions: PropTypes.arrayOf(PropTypes.object),
      onSearchFinish: PropTypes.func,
      width: PropTypes.number,
    };

    static defaultProps = {
      getField: null,
      saveFields: null,
      saveHeaders: null,
      saveFile: null,
      filterSelect: false,
      selectOptions: null,
      onSearchFinish: null,
    };

    constructor(props) {
      super(props);
      this.state = {
        filteredData: this.props[dataField],
        selectedFilterType: props.filterSelect ? props.selectOptions[0] : null,
      };
      this._onFilterChange = this._onFilterChange.bind(this);
      this._onSortChange = this._onSortChange.bind(this);
      this._getFieldValue = this._getFieldValue.bind(this);
      this.updateFilteredData = this.updateFilteredData.bind(this);

      this._filterText = null;
      this._sortOrder = 1;
      this._sortField = null;
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.props[dataField] !== prevProps[dataField]) {
        this.updateFilteredData(this.props[dataField]);
      }
      if (this.state.selectedFilterType !== prevState.selectedFilterType) {
        this._onChange();
      }
    }

    updateFilteredData(filteredData) {
      this.setState({ filteredData });
    }

    selectFilterType(filter) {
      this.setState({ selectedFilterType: filter });
    }

    _onFilterChange(e) {
      const filterBy = e.target.value.toLowerCase().trim();
      this._filterText = filterBy;
      this._onChange();
    }

    _getFieldValue(row, field) {
      if (this.props.getField && typeof this.props.getField === 'function')
        return this.props.getField(row, field);
      return row[field];
    }

    _onSortChange(e, order) {
      if (order) this._sortOrder = order;
      else this._sortOrder = 1;
      this._sortField = e;
      this._onChange();
    }

    _onChange() {
      const data = this.props[dataField];
      let filterBy = this._filterText;

      const size = data.length;
      let filtered = [];
      let searchFields = fields;
      if (this.state.selectedFilterType)
        searchFields = [this.state.selectedFilterType.value];

      if (filterBy && filterBy !== '') {
        for (let index = 0; index < size; index += 1) {
          for (let idx = 0; idx < searchFields.length; idx += 1) {
            const value = this._getFieldValue(data[index], searchFields[idx]);
            filterBy = filterBy.replace(/\\/g, '&#92');
            if (value) {
              const match = value
                .toString()
                .toLowerCase()
                .search(filterBy);
              if (match !== -1) {
                filtered.push(data[index]);
                break;
              }
            }
          }
        }
      } else {
        filtered = data.slice(0);
      }

      if (this.sortField) {
        filtered = filtered.sort((a, b) => {
          const fieldValue =
            this._getFieldValue(a, this._sortField) >
            this._getFieldValue(b, this._sortField)
              ? 1
              : 0;
          const val =
            this.getFieldValue(a, this._sortField) <
            this._getFieldValue(b, this._sortField)
              ? -1
              : fieldValue;
          return val * this._sortOrder;
        });
      }
      if (this.props.onSearchFinish) this.props.onSearchFinish();
      this.setState({
        filteredData: filtered,
      });
    }

    _getText(index) {
      let text = '';
      this.props.saveFields.forEach((f, idx, a) => {
        const value = this._getFieldValue(this.state.filteredData[index], f);
        text += (value || '') + (idx + 1 < a.length ? ',' : '');
      });
      return text;
    }

    _asText() {
      let text = `${this.props.saveHeaders.join(',').toUpperCase()}\n`;
      for (let i = 0; i < this.state.filteredData.length; i += 1) {
        text += this._getText(i);
        text += '\n';
      }
      return text;
    }

    render() {
      const {
        saveFields,
        filterSelect,
        saveFile,
        selectOptions,
        width,
      } = this.props;

      const downloadWidth = saveFields ? 40 : 0;
      const selectWidth = filterSelect ? 110 : 0;
      const formWidth = width ? width - (downloadWidth + selectWidth) : '100%';

      return (
        <div>
          <div style={{ width }}>
            <FormGroup
              style={{
                width: `${width ? `${formWidth.toString()}px` : formWidth}`,
                height: '38px',
                display: 'inline-block',
                verticalAlign: 'middle',
                margin: 0,
              }}
            >
              <InputGroup style={{ height: '38px' }}>
                <Addon>
                  <i className="fa fa-search" />
                </Addon>
                <FormControl
                  style={{ height: '38px' }}
                  onChange={this._onFilterChange}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </FormGroup>

            {saveFields && (
              <ButtonToolbar
                style={{ display: 'inline-block', verticalAlign: 'middle' }}
              >
                <ButtonGroup>
                  <Button
                    style={{ height: '38px' }}
                    onClick={() => {
                      saveText(this._asText(), `${saveFile}.txt`);
                    }}
                  >
                    <Tooltip text="Download data">
                      <i className="fa fa-download" />
                    </Tooltip>
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            )}
            {filterSelect && (
              <div
                style={{
                  width: selectWidth,
                  display: 'inline-block',
                  verticalAlign: 'middle',
                }}
              >
                <Select
                  isSearchable={false}
                  onChange={filter => this.selectFilterType(filter)}
                  defaultValue={selectOptions[0]}
                  options={selectOptions}
                  styles={{
                    control: selectStyles => ({
                      ...selectStyles,
                      zIndex: 100,
                    }),
                    menu: selectStyles => ({
                      ...selectStyles,
                      zIndex: 100,
                    }),
                  }}
                />
              </div>
            )}
          </div>
          <ComposedComponent
            {...this.props}
            {...{ [dataField]: this.state.filteredData }}
            onSort={this._onSortChange}
          />
        </div>
      );
    }
  };

export default Filter;
